module.exports = __webpack_public_path__ + "img/aperol-spritz.fd2a7c2e.jpg";